module.exports = __webpack_public_path__ + "bullseye-telecom_logo.ac7d4b8f79f2523cfccdb6bb3f76dc9f.png";